<template>
  <div class="nav">
    <a-breadcrumb :class="hide ? 'nav-hide' : 'layout-2'">
      <span slot="separator">
        <a-icon style="color: #00000073; height: 10px; width: 6px; font-size: 10px; padding-right: 10px" type="right" />
      </span>
      <!-- <a-breadcrumb-item key="index">
        <template>
          <router-link :to="'/'">
            <span style="font-size: 12px">首页</span>
          </router-link>
        </template>
      </a-breadcrumb-item> -->
      <a-breadcrumb-item v-for="item in breadcrumbs" :key="item.idx" @click="clickBreadcrumbItem(item)">
        <template v-if="!item.path">
          {{ item.name }}
        </template>
        <template v-else>
          <router-link :to="item.path">
            <span style="font-size: 12px">{{ item.name }}</span>
          </router-link>
        </template>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <button :class="flag & 4 ? 'handle' : 'handle-hide'" :style="{ top: hide ? '51px' : '112px', right: '25px' }" @click="hide = !hide">
      <a-icon v-if="hide" type="menu-unfold" style="color: #bbb; font-size: 20px; height: 20px; margin-left: 6px" />
      <a-icon v-else type="menu-fold" style="color: #bbb; font-size: 20px; height: 20px; margin-left: 6px" />
    </button>
  </div>
</template>
<script lang="ts">
import { MenuModule } from "@/store/modules/menu";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// import { Route } from "vue-router";
// import { UserModule } from "@/store/modules/user";
// import { computedStrLen } from "@/utils/util";

@Component({
  name: "Nav",
})
export default class extends Vue {
  // computedStrLen: any = computedStrLen;
  // get userInfo() {
  //   return UserModule.userInfo;
  // }

  @Prop({ default: 6 })
  flag: any;

  hide = false;
  breadcrumbs: any[] = [];

  @Watch("flag", { immediate: true })
  onFlagChange(val: any) {
    this.hide = val !== 6;
  }

  // 获取当前导航
  @Watch("$store.state.Menu.menuItemKey") // { immediate: true }
  @Watch("$route")
  onMenuChange() {
    // console.log("nav-update", MenuModule.menuItemKey, MenuModule.menuListMap);
    const menuItem: any = MenuModule.menuListMap[MenuModule.menuItemKey];
    console.log("menuItem", menuItem);
    if (!menuItem?.idx) {
      return; // 未找到对应的菜单
    }
    console.log(this.$route.meta);
    if (this.$route.meta?.breadcrumb) {
      this.breadcrumbs = this.$route.meta.breadcrumb;
      return;
    }
    // 使用/拆分menuItem.idx为数组
    const idxArr = menuItem.idx.split("/");
    let reslist: any = [];
    for (let i = 0; i < idxArr.length; i++) {
      // const idx = idxArr.slice(0, i + 1).join("/");
      // reslist = [...reslist, MenuModule.menuListMap[idx]];
      const item = MenuModule.menuListMap[idxArr[i]];
      if (item) {
        reslist.push(item);
      }
    }
    console.log("nav-update", reslist);
    this.breadcrumbs = reslist;
  }

  // 点击面包屑
  clickBreadcrumbItem(item: any) {
    // 点击在目前继承iframe的架构体系下是没有意义的，所以暂时取消面包屑的点击事件
    // 如果openType===3 iframe嵌入替换store中的clickItem  其他走项目内的路由导航
    // if (item.openType === 3) {
    //   this.$router.push({ name: "ipath", query: { p: item.path0 } });
    // } else {
    //   this.$router.push(item.path);
    // }
  }
}
</script>
<style lang="less" scoped>
.nav {
  width: 100%;
  background: @bg-color;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
  z-index: 1;
  // position: relative;

  .layout-2 {
    height: @height-nav;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 20px;
    transition: all 0.1s;
  }
  // .layout-3 {
  //   width: 1400px;
  //   height: 60px;
  //   display: flex;
  //   justify-content: flex-start;
  //   align-items: center;
  // }
  // font-size: 16px;
  // line-height: 48px;
  // padding: 0 0 0 25px;
  // margin: 0 0 4px 0;
  .nav-hide {
    height: 0px !important;
    overflow: hidden;
    flex: 0 1 auto !important;
    // min-height: 0 !important;
    transition: all 0.1s;
  }
}
.handle-hide {
  display: none;
}
.handle {
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: rotate(90deg);
  // transform: translateY(-50%);
  z-index: 999;
  border-right: 1px solid #ccc;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  height: 32px;
  border-radius: 0 4px 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  // width: 2px;
  width: 14px;
  overflow: hidden;
  transition: all 0.1s;
}
</style>
